/** Stable key for grouping a mentor's payments (registered mentor, email, or single txn). */
export const getPaymentGroupKey = (payment) => {
  if (!payment) return "";
  if (payment.mentor_id) return `mentor:${payment.mentor_id}`;
  const email = String(payment.email || "")
    .trim()
    .toLowerCase();
  if (email) return `email:${email}`;
  return `txn:${payment.transaction_id || payment.id}`;
};

export const buildPaymentCountByKey = (payments) => {
  const counts = {};
  (Array.isArray(payments) ? payments : []).forEach((payment) => {
    const key = getPaymentGroupKey(payment);
    if (!key) return;
    counts[key] = (counts[key] || 0) + 1;
  });
  return counts;
};
